import { IExecutionOptions } from '../models/query';
import { IQueryOptionsAllocations } from '../models/query/options';
import { BaseValueCollectionQuery } from './BaseValueCollectionQuery';

export class AllocationsQuery extends BaseValueCollectionQuery<IQueryOptionsAllocations> {
	initialize(executionOptions: IExecutionOptions) {
		this.fillKeyFromQuery('code', 'codeQuery', executionOptions);
		this.fillKeyFromQuery('key', 'keyQuery', executionOptions);
	}
	getOptions(): IQueryOptionsAllocations {
		const { entityType, entityConditional, code, codeQuery, key, keyQuery, collectionItemConditional, collectionItemValueConditional, sort, index, startIndex, endIndex, entityKey, entityIndex, options = {} } = this.queryOptions;
		return {
			entityType,
			entityConditional,
			code,
			codeQuery,
			key,
			keyQuery,
			collectionItemConditional,
			collectionItemValueConditional,
			sort,
			index,
			startIndex,
			endIndex,
			entityKey,
			entityIndex,
			...(options.allocations || {}),
		};
	}
	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		return this.getRawValueOrRootKey(executionOptions);
	}
}